import CascaderPanel from './src/cascader-panel';

/* istanbul ignore next */
CascaderPanel.install = function (Vue) {
  Vue.component(CascaderPanel.name, CascaderPanel);
};

export default CascaderPanel;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/element-ui/packages/cascader-panel/index.js